import ky from "ky";

const reviewClient = ky.create({
  prefixUrl: "https://add-review-nps-430106833236.europe-central2.run.app",
});

const updateReviewClient = ky.create({
  prefixUrl: "https://update-review-nps-430106833236.europe-central2.run.app",
});

export const sendPerformanceReview = async ({
  score: score,
  country: country,
  street: street,
  city: city,
  bookingNumber: bookingNumber,
}) => {
  const res = await reviewClient.post("add-data", {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      accept: "application/json",
    },
    timeout: 20000,
    body: JSON.stringify({
      street,
      city,
      score,
      country,
      bookingNumber,
    }),
  });

  const data = res.json();
  return data;
};

export const updatePerformanceReview = ({ feedback: feedback, id: id }) => {
  if (!id) return;
  return updateReviewClient.post("insert-feedback", {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      accept: "application/json",
    },
    body: JSON.stringify({
      feedback,
      id,
    }),
  });
};
